module.exports = __webpack_public_path__ + "img/wide.45c529fe.jpg";